module.exports = __webpack_public_path__ + "img/1492873858.6b93e43a.jpg";